// splashLoadingBar.js
var SplashLoadingBar = pc.createScript('splashLoadingBar');

SplashLoadingBar.attributes.add('progressImage', {type: 'entity'});
SplashLoadingBar.attributes.add('progressImageMaxWidth', {type: 'number'});
SplashLoadingBar.attributes.add('progressText', {type: 'entity'});
SplashLoadingBar.attributes.add('leftCover', {type: 'entity'});
SplashLoadingBar.attributes.add('rightCover', {type: 'entity'});

// initialize code called once per entity
SplashLoadingBar.prototype.initialize = function () {
    
    SplashLoadingBar.instance = this;

    this.app.on('splashLoadingBar:loadAssets',this.preloadAssets,this);

    this.setProgress(0.1);
    this.increase = true;
    this.app.fire('UserData');
};

SplashLoadingBar.prototype.loadTextureAsset = function() {

    var assets = this.app.assets.findByTag("GameTexture");

    var currentProgressIndex = this.progress;
    var loadAssets = function (val) {

        if (val < assets.length) {
            PreloadManager.instance.loadSingleItem(assets[val], function (status) {
                if (status == true) {
                    //SplashLoadingBar.instance.setProgress(0.4 + ((val + 1) / (assets.length)) / 2);
                    let calculatedProgressIndex =  currentProgressIndex + (val/PreloadManager.instance.getLoadingTotalAssetCount())*(0.8);
                     SplashLoadingBar.instance.setProgress(calculatedProgressIndex);
                    val += 1;
                    loadAssets(val);
                }
            });
        }
        else {
            SplashLoadingBar.instance.loadPreloadAssets();
        }
    };

    loadAssets(0);

};
SplashLoadingBar.prototype.loadPreloadAssets = function() {
    
    let i = 0;
    
    //this.setProgress(0.4);

    var assets = this.app.assets.findByTag("preload");
    // console.log("Preload Sayısı: " + assets.length);

    var currentProgressIndex = this.progress;
    var loadAssets = function (val) {

        if (val < assets.length) {
            PreloadManager.instance.loadSingleItem(assets[val], function (status) {
                if (status == true) {
                    let calculatedProgressIndex =  currentProgressIndex + (val/PreloadManager.instance.getLoadingTotalAssetCount())*(0.8);
                     SplashLoadingBar.instance.setProgress(calculatedProgressIndex);
                    val += 1;
                    loadAssets(val);
                }
            });
        }
        else {
            SplashLoadingBar.instance.setProgress(1);
            SplashLoadingBar.instance.app.fire('game:Ready', 'Menu');

        }
    };

    loadAssets(0);
};


SplashLoadingBar.prototype.setProgress = function (value) {    
    // clamp value between 0 and 1
    value = pc.math.clamp(value, 0, 1);
    this.progress = value;
    
    var width = pc.math.lerp(0, this.progressImageMaxWidth, value);

    this.progressImage.element.width = width;
    
    var leftCoverWidthRate = pc.math.lerp(-212.023,-634.566, value);
    var rightCoverWidthRate = pc.math.lerp(212.023,634.566, value);

    this.leftCover.setLocalPosition(leftCoverWidthRate, this.leftCover.getLocalPosition().y, this.leftCover.getLocalPosition().z);
    this.rightCover.setLocalPosition(rightCoverWidthRate, this.rightCover.getLocalPosition().y, this.rightCover.getLocalPosition().z);

    this.progressText.element.text = "LOADING % " + Math.ceil(value*100);
};


